// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"606f75dc","79":"b870d68d","286":"2d4757eb","429":"22f94eca","482":"696532fb","808":"5c353119","871":"e352440a"}[chunkId] + ".chunk.js";
};